






import { Component, Vue } from 'vue-property-decorator';
import ResizeObserver from 'resize-observer-polyfill';

@Component
export default class Popup extends Vue {
  private resizeObserver: ResizeObserver | null = null;

  public mounted() {
    if (this.resizeObserver) return;
    this.resizeObserver = new ResizeObserver(this.handleResize);
    this.resizeObserver.observe(window.document.body);
    this.handleResize();
  }

  public destroyed() {
    if (this.resizeObserver !== null) this.resizeObserver.disconnect();
  }

  private handleResize() {
    const popup = (this.$refs.popup as HTMLElement);
    popup.style.transform = 'translate(-50%, -50%)';
    const newScale = Math.min(1, window.innerWidth / popup.clientWidth);
    popup.style.transform = `translate(-50%, -50%) scale(${newScale})`;
  }
}
